
























import Vue from 'vue'
import { AdditionalFieldItem } from '@/model/additional-fields/AdditionalFieldItem'
import MultiLanguagesDialog from '@/components/additional-fields/MultiLanguagesDialog.vue'
import { AdditionalField } from '@/model/additional-fields/AdditionalField'
import { UiLanguageItem, UiLanguageList } from '@/types'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { DxHtmlEditor } from 'devextreme-vue/html-editor'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { locale, loadMessages } from "devextreme/localization"

export interface LanguageListItem {
  id: number
  additionalId: number
  code: string
  text: string
}

interface ComponentData {
  showMultiLanguagesDialog: boolean
  value: string
  multiLanguagesDialogData: LanguageListItem[]
}

export default Vue.extend({
  name: 'AdditionalFieldsMultiLanguageTextArea',

  components: {
    MultiLanguagesDialog,
    DxHtmlEditor
  },

  props: {
    item: {
      type: Object as () => AdditionalField
    },
    items: {
      type: Array as () => Array<AdditionalFieldItem>
    },
    defaultValue: String,
    profitCenterMultiLanguageLoading: Boolean
  },

  data (): ComponentData {
    return {
      showMultiLanguagesDialog: false,
      value: '',
      multiLanguagesDialogData: []
    }
  },

  watch: {
    items (newVal: Array<AdditionalFieldItem>): void {
      if(newVal) {
        this.multiLanguagesDialogData = []
        this.setData()
      }
    },

    profitCenterMultiLanguageLoading (newVal: boolean): void {
      if(!newVal) {
        this.showMultiLanguagesDialog = false
      }
    }
  },

  computed: {
    uiLanguageList (): UiLanguageList {
      return this.$store.state.uiLanguageList
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },
  },

  methods: {
    saveMultiLanguageList (payload: LanguageListItem[]): void {
      this.$emit('saveMultiLanguageList', payload, this.item)
    },

    onMultiLanguagesDialogOpen (): void {
      this.showMultiLanguagesDialog = true
    },

    onMultiLanguagesDialogClose (): void {
      this.showMultiLanguagesDialog = false
    },

    setData (): void {
      this.uiLanguageList.forEach((item: UiLanguageItem) => {
        let foundItem: AdditionalFieldItem | undefined = this.items.find((i: AdditionalFieldItem) => item.syzId === parseInt(i.designation))
        if(foundItem) {
          if(item.syzId === this.selectedLanguageId) {
            this.value = foundItem ? foundItem.value : this.defaultValue
          }

          this.multiLanguagesDialogData.push({
            id: item.syzId,
            additionalId: foundItem.id,
            code: item.code,
            text: foundItem ? foundItem.value : ''
          })
        }
      })
    }
  },

  created () {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)

    if(this.items) {
      this.setData()
    }
  }

})
